export enum UserRole {
  AdminPlay = 'ROLE_ADMIN_PLAY',
  Developer = 'ROLE_DEVELOPER',
  Teacher = 'ROLE_TEACHER',
  Student = 'ROLE_STUDENT',
  ExternalToken = 'ROLE_EXTERNAL_TOKEN'
}
